'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbFolder = fbFolder;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    Folder
    --------------------------------
    
    <div fb-folder="{'default-open': 'sm-down'}"></div>
    <div></div>

*/

function fbFolder() {
    return {
        restrict: 'A',
        scope: {
            target: '@',
            initOpen: '@'
        },
        controller: ["$scope", "$window", "$timeout", "$element", "common", "$attrs", "Breakpoints", function controller($scope, $window, $timeout, $element, common, $attrs, Breakpoints) {
            'ngInject';

            var init, toggle, close, isInitiallyOpen, breakpointMatch;

            init = function init() {
                if ($scope.target) {
                    $element.targetEl = angular.element($scope.target).addClass('folder-content');
                } else {
                    $element.targetEl = $element.next().addClass('folder-content');
                }

                $element.addClass('folder').on('click', function (e) {
                    e.preventDefault();
                    toggle();
                });
                $element.targetEl.find('[fb-folder-close]').on('click', function (e) {
                    e.preventDefault;
                    close();
                });
                // initially closed, use 'init-open' option to open by default
                if (isInitiallyOpen()) {
                    toggle();
                }
            };

            toggle = function toggle() {
                $element.toggleClass('is-open');
                $element.targetEl.toggleClass('is-open');
            };

            close = function close() {
                $element.removeClass('is-open');
                $element.targetEl.removeClass('is-open');
            };

            isInitiallyOpen = function isInitiallyOpen() {
                if (!$scope.initOpen) {
                    return false;
                }
                return breakpointMatch($scope.initOpen);
            };

            breakpointMatch = function breakpointMatch(breakpoint) {
                var bp = breakpoint.split('-')[0];
                var bpRange = breakpoint.split('-')[1];
                var min = 0;
                var max = 99999;

                if (bpRange === 'up') {
                    min = _lodash2.default.find(Breakpoints, { name: bp }).min;
                } else if (bpRange === 'down') {
                    max = _lodash2.default.find(Breakpoints, { name: bp }).max;
                } else if (bpRange === 'only' || bpRange === undefined) {
                    min = _lodash2.default.find(Breakpoints, { name: bp }).min;
                    max = _lodash2.default.find(Breakpoints, { name: bp }).max;
                }

                return $window.innerWidth >= min && $window.innerWidth <= max;
            };

            $timeout(function () {
                init();
            });
        }]
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fb-folder.js
// module id = 715
// module chunks = 0